"use client";

import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";

import { RootState } from "@/app/store";
import { BlogServices } from "@/services";

function useLatestBlog() {
  const { selectedCategory } = useSelector((state: RootState) => state.blog);
  const { data: categories } = BlogServices().useGetAllBlogCategory();

  const router = useRouter();
  const viewBlog = (blog_id: string) => {
    router.push(`/blog/${blog_id}`);
  };
  const { data: allBlogs, isLoading: blogLoading } =
    BlogServices().useGetAllBlog({
      category: selectedCategory._id,
      onlyLatest: true,
    });

  return { blogLoading, allBlogs, categories, router, viewBlog };
}

export default useLatestBlog;
